import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Github } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-gray-300 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white text-2xl">🚢</span>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Dockyard Solutions</h3>
                <p className="text-sm text-gray-400">Maintenance Prediction System</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6">
              Advanced predictive maintenance solutions for maritime fleets worldwide.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Github size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="/maintenance" className="hover:text-white transition-colors">Maintenance Schedule</a></li>
              <li><a href="/analytics" className="hover:text-white transition-colors">Analytics</a></li>
              <li><a href="/reports" className="hover:text-white transition-colors">Reports</a></li>
              <li><a href="/support" className="hover:text-white transition-colors">Support Center</a></li>
              <li><a href="/docs" className="hover:text-white transition-colors">Documentation</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Resources</h4>
            <ul className="space-y-3">
              <li><a href="/blog" className="hover:text-white transition-colors">Blog & News</a></li>
              <li><a href="/api" className="hover:text-white transition-colors">API Documentation</a></li>
              <li><a href="/integrations" className="hover:text-white transition-colors">Integrations</a></li>
              <li><a href="/downloads" className="hover:text-white transition-colors">Downloads</a></li>
              <li><a href="/status" className="hover:text-white transition-colors">System Status</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="mt-1 text-blue-400" size={18} />
                <div>
                  <p className="font-medium">Address</p>
                  <p className="text-sm text-gray-400">
                    No. 233, Jayantha Mallawarachchi Mawatha, Colombo 14, Sri Lanka
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="text-blue-400" size={18} />
                <div>
                  <p className="font-medium">Phone</p>
                  <p className="text-sm text-gray-400">+94 11 234 5678</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="text-blue-400" size={18} />
                <div>
                  <p className="font-medium">Email</p>
                  <a 
                    href="mailto:support@dockyard.com" 
                    className="text-sm text-blue-400 hover:text-blue-300 transition-colors"
                  >
                    support@dockyard.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Dockyard Total Solution (Pvt) Ltd. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm">
              <a href="/privacy" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="/terms" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="/cookies" className="hover:text-white transition-colors">Cookie Policy</a>
              <a href="/sitemap" className="hover:text-white transition-colors">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;